module.exports = __webpack_public_path__ + "img/about_img2_m.c8dc3a5d.png";